import Rack from './Rack';

export default Rack;